import { render, staticRenderFns } from "./PlacesTopMatter.vue?vue&type=template&id=71497c88"
import script from "./PlacesTopMatter.vue?vue&type=script&lang=ts"
export * from "./PlacesTopMatter.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports